export const tables = {
    metall_type: [
        {
            actual: true,
            name: "bazovii__osnovanie__1200x700",
            pageName: "bazovii",
            tempName: "bazovii__osnovanie",
            glbName: "bazovii.glb",
            nextMenu: "table_bazovii",
            menuTitle: 'Стол "Базовый (СП)"',
            title: 'Стол "Базовый (СП)"',
            imgName: "stol-b.webp",
            allArrTable: "allTableBazovii",
            defaultWidth: "1200",
            defaultDepth: "700",
        },
        {
            actual: true,
            name: "komfort__osnovanie__1200x700",
            pageName: "komfort",
            tempName: "komfort__osnovanie",
            glbName: "komfort.glb",
            nextMenu: "table_komfort",
            menuTitle: 'Стол "Комфорт (СПП)"',
            title: 'Стол "Комфорт (СПП)"',
            imgName: "stol-komfort.webp",
            allArrTable: "allTableKomfort",
            defaultWidth: "1200",
            defaultDepth: "700",
        },
        {
            actual: true,
            name: "spr__osnovanie__1200x700",
            pageName: "spr",
            tempName: "spr__osnovanie",
            glbName: "spr.glb",
            nextMenu: "table_spr",
            menuTitle: 'Стол "СПР"',
            title: 'Стол "СПР"',
            imgName: "stol-spr.webp",
            allArrTable: "allTableSpr",
            defaultWidth: "1200",
            defaultDepth: "700",
        },
        {
            actual: true,
            name: "spb__osnovanie__1200x500",
            pageName: "spb",
            tempName: "spb__osnovanie",
            title: 'Стол "СПБ"',
            nextMenu: "table_spb",
            menuTitle: 'Стол "СПБ"',
            glbName: "spb.glb",
            imgName: "stol-spb.webp",
            allArrTable: "allTableSpb",
            defaultWidth: "1200",
            defaultDepth: "500",
        },
        {
            actual: true,
            name: "ostrov__osnovanie__1200x700",
            pageName: "ostrov",
            tempName: "ostrov__osnovanie",
            title: 'Стол "Остров"',
            nextMenu: "table_ostrov",
            menuTitle: 'Стол "Остров"',
            glbName: "ostrov.glb",
            imgName: "ostrov.webp",
            allArrTable: "allTableOstrov",
            defaultWidth: "1200",
            defaultDepth: "700",
        },
        {
            actual: true,
            name: "verstak__stoleshnitsa__1200x700",
            pageName: "verstak",
            tempName: "verstak__stoleshnitsa",
            title: 'Стол "Верстак"',
            nextMenu: "table_verstak",
            menuTitle: 'Стол "Верстак"',
            glbName: "verstak.glb",
            imgName: "stol_verstak.webp",
            allArrTable: "allTableVerstak",
            defaultWidth: "1200",
            defaultDepth: "700",
        },
        {
            actual: false,
            name: "",
            title: "СПГ",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "Двухуровневый",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СРП",
            imgName: "",
        },
        {
            actual: true,
            name: "upakovochnii__osnovanie__1200x700",
            pageName: "upakovochnii",
            tempName: "upakovochnii__osnovanie",
            title: 'Стол "Упаковочный"',
            nextMenu: "table_upakovochnii",
            menuTitle: 'Стол "Упаковочный"',
            glbName: "upakovochnii.glb",
            imgName: "upakovochnii.webp",
            allArrTable: "allTableUpakovochnii",
            defaultWidth: "1200",
            defaultDepth: "700",
        },
        {
            actual: true,
            name: "ksm__osnovanie__1000x600",
            pageName: "ksm",
            tempName: "ksm__osnovanie",
            title: "Комплект стола монтажника",
            menuTitle: "Комплект стола монтажника",
            nextMenu: "table_ksm",
            glbName: "ksm.glb",
            imgName: "ksm.webp",
            allArrTable: "allTableKSM",
            defaultWidth: "1000",
            defaultDepth: "600",
        },
        {
            actual: true,
            name: "raskroinii__osnovanie__1200x1500",
            pageName: "raskroinii",
            tempName: "raskroinii__osnovanie",
            title: 'Стол "Раскройный"',
            menuTitle: 'Стол "Раскройный"',
            nextMenu: "table_raskroinii",
            glbName: "raskroinii.glb",
            imgName: "raskroinii.webp",
            allArrTable: "allRaskroinii",
            defaultWidth: "1200",
            defaultDepth: "1500",
        },
        {
            actual: true,
            name: "smk__osnovanie__700x700",
            pageName: "smk",
            tempName: "smk__osnovanie",
            title: 'Стол "СМК"',
            menuTitle: 'Стол "СМК"',
            nextMenu: "table_smk",
            glbName: "smk.glb",
            imgName: "stol__smk.webp",
            allArrTable: "allTableSMK",
            defaultWidth: "700",
            defaultDepth: "700",
        },
        {
            actual: true,
            name: "ssu__osnovanie__1050x700",
            pageName: "ssu",
            tempName: "ssu__osnovanie",
            title: 'Стол "ССУ"',
            menuTitle: 'Стол "ССУ"',
            nextMenu: "table_ssu",
            glbName: "ssu.glb",
            imgName: "stol__ssu.webp",
            allArrTable: "allTableSSU",
            defaultWidth: "1050",
            defaultDepth: "700",
        },
    ],
    construct_type: [
        {
            actual: false,
            name: "",
            title: "СПП-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СПД-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СПВ-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СПЗ-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СПБ-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СРП-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СП-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СПО-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СУ-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СПН-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СППС-КП",
            imgName: "",
        },
        {
            actual: false,
            name: "",
            title: "СД-КП",
            imgName: "",
        },
    ],
};
